import { useTranslation } from 'react-i18next'

// Traduce el error_code que manda el backend (ver pkg/apperror). Si el
// backend todavía no migró ese error a un código (fallback legacy sin
// error_code), se muestra el texto plano que vino en la respuesta.
export const useApiErrorMessage = () => {
  const { t, i18n } = useTranslation(['errors', 'common'])
  return (error: any): string => {
    const errorCode = error?.response?.data?.error_code
    if (errorCode && i18n.exists(errorCode, { ns: 'errors' })) {
      return t(errorCode, { ns: 'errors' })
    }
    const rawMessage = error?.response?.data?.error
    if (rawMessage) {
      return rawMessage
    }
    return t('errors.generic', { ns: 'common' })
  }
}
